import { isStringEmail, isStringPhone, formatStringAsNumber } from '../../utils/main'
import { generateBulkSmsContact } from '../reducers/statics/consts'

export const SET_INPUT_OFFER_CONTACT_US = "SET_INPUT_OFFER_CONTACT_US";
export const SET_DID_SUBMIT_OFFER_CONTACT_US = "SET_DID_SUBMIT_OFFER_CONTACT_US";
export const SET_ERROR_MESSAGE_OFFER_CONTACT_US = "SET_ERROR_MESSAGE_OFFER_CONTACT_US";
export const SET_LOADING_OFFER_CONTACT_US = "SET_LOADING_OFFER_CONTACT_US";

export const setInput = (value, id) => {
    return (dispatch, getState) => {
        dispatch({type: SET_INPUT_OFFER_CONTACT_US, value, id})
    }
}

export const submitForm = () => {
    return (dispatch, getState) => {
        const { submit, name, phone, email } = getState().OfferContactUsReducer;
        if(submit.didSubmit) return;
        if(isStringEmail(email) && name.length >= 3 && isStringPhone(phone)) {
            dispatch({type: SET_LOADING_OFFER_CONTACT_US, newValue: true})
            fetch(generateBulkSmsContact(
                    name, email, phone, 
                    formatStringAsNumber(getTotalSelectedSMS(getState()).messages), 
                    `This user wants to buy ${formatStringAsNumber(getTotalSelectedSMS(getState()).messages)} SMS`
                ),
            {
                method: "POST"
            })
            .then(r => r.body)
            .then(res => {
                //console.log(res);
                
                //if(res == "Success") {
                    dispatch({type: SET_DID_SUBMIT_OFFER_CONTACT_US});
                // } else {
                //     throw({message: "Unknown error occurred."})
                // }
            })
            .catch(err => {
                dispatch({type: SET_ERROR_MESSAGE_OFFER_CONTACT_US, message: err.message})
            })
        } else {
            dispatch({
                type: SET_ERROR_MESSAGE_OFFER_CONTACT_US, 
                message: 
                    !isStringPhone(phone) ? "Please enter a valid phone number" :
                    (
                        !isStringEmail(email) ? "Please enter a valid email address" :
                        (name.length < 3 ? "Please enter your full name" : "Unknown error occurred.")
                    )
            });
        }
    }
}

const getTotalSelectedSMS = (state) => {
    const { bulkPackagesSelected } = state.DIDsReducer;
    const { bulkPackages } = state.PlansReducer;

    var bulkSummary = {
        messages: 0,
        price: 0,
    };
    Object.keys(bulkPackagesSelected).forEach(key => {
        const count = bulkPackagesSelected[key];
        const item = bulkPackages.find(el => el.id == key);
        
        bulkSummary = {
            messages: bulkSummary.messages + (Number(item.amount.replace(/,/g, '')) * count),
            price: bulkSummary.price + (Number(item.price.replace(/,/g, '')) * count),
        }
    })

    return bulkSummary;
}